module.exports = __webpack_public_path__ + "static/media/spreadsheet_icon.91608fb7.svg";